import { render, staticRenderFns } from "./material-icons.vue?vue&type=template&id=b0e0fd9a&scoped=true&"
import script from "./material-icons.vue?vue&type=script&lang=ts&"
export * from "./material-icons.vue?vue&type=script&lang=ts&"
import style0 from "./material-icons.vue?vue&type=style&index=0&id=b0e0fd9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e0fd9a",
  null
  
)

export default component.exports